import { Coupon } from '@jbhi-fi/components/src/types';
import { createContext, ReactNode } from 'react';
import { CustomerApi } from '../customerApi';

export interface Subscription {
  id?: string;
  type?: string;
  isActive?: boolean;
  startDate?: Date;
  endDate?: Date;
  parentId?: string;
  queryStatus?: string;
  error?: number;
  coupons?: Array<Coupon>;
}

export type SubscriptionApi = {
  subscriptions: { [name: string]: Subscription | undefined };
  refreshSubscriptions: () => void;
  customer: CustomerApi['customer'];
  customerLoading: CustomerApi['loading'];
  customerError: CustomerApi['error'];
  linkedId: CustomerApi['linkedId'];
};

export const SubscriptionApi = createContext<SubscriptionApi | undefined>(undefined);

export type SubscriptionApiProviderProps = {
  children: ReactNode;
  subscriptionTypes: Array<string>;
};
